import { AxiosResponse } from 'axios';
import api from 'api/base';
import { GetPartnerHeaderFeaturesResponse } from 'features/header/api/types';
import { AdminFeatureCategory } from 'shared/enums/admin-feature-category.enum';

export const getHeaderFeaturesAPI = async (): Promise<
  AxiosResponse<GetPartnerHeaderFeaturesResponse>
> => {
  return api.get<GetPartnerHeaderFeaturesResponse>(
    `/partner-features?featureCategory=${AdminFeatureCategory.HEADER}`
  );
};
